<template>
  <div class="videoAliplyerV2Single">
    <vue-aliplayer-v2
      v-show="isShowVideo"
      ref="VueAliplayerV2"
      :options="AliplayerV2Opts"
    />
  </div>
</template>

<script>
export default {
  name: 'videoAliplayerV2',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      isShowVideo: true,
      AliplayerV2Opts: null,
      AliplayerV2Opts_default: {
        skinLayout: [
          {
            name: 'bigPlayButton',
            align: 'blabs',
            x: '50%',
            y: '50%',
          },
          {
            name: 'H5Loading',
            align: 'cc',
          },
          {
            name: 'errorDisplay',
            align: 'tlabs',
            x: 0,
            y: 0,
          },
          {
            name: 'infoDisplay',
          },
          {
            name: 'tooltip',
            align: 'blabs',
            x: 0,
            y: 56,
          },
          {
            name: 'thumbnail',
          },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              {
                name: 'progress',
                align: 'blabs',
                x: 0,
                y: 44,
              },
              {
                name: 'playButton',
                align: 'tl',
                x: 15,
                y: 12,
              },
              {
                name: 'timeDisplay',
                align: 'tl',
                x: 10,
                y: 7,
              },
              {
                name: 'fullScreenButton',
                align: 'tr',
                x: 10,
                y: 12,
              },
              {
                name: 'volume',
                align: 'tr',
                x: 5,
                y: 10,
              },
            ],
          },
        ],
        showBarTime: 3000, // 控制栏自动隐藏时间（ms）
        height: '100%', //51.75 50.625
        cover: '', // 播放器默认封面图片，请填写正确的图片url地址。需要autoplay为’false’时，才生效。Flash播放器封面也需要开启允许跨域访问。
        autoplay: false, // 播放器是否自动播放，在移动端autoplay属性会失效。Safari11不会自动开启自动播放如何开启。
        controlBarVisibility: 'click', // 控制面板的实现，默认为‘hover’。可选的值为：‘click’、‘hover’、‘always’。
        source: null, //'//player.alicdn.com/video/editor.mp4',
        isLive: false, //切换为直播流的时候必填; 播放内容是否为直播，直播时会禁止用户拖动进度条
        // format: 'm3u8'  //切换为直播流的时候必填
      },
    }
  },
  created() {
    this.AliplayerV2Opts = Object.assign(
      {},
      this.AliplayerV2Opts_default,
      this.options
    )
    console.debug(this.options)
  },
  watch: {
    options: {
      // 在collapseForm.vue页面点击提交时，这里传递数据
      handler(newVal, oldVal) {
        console.debug('item.value:', newVal)
        this.AliplayerV2Opts = Object.assign(
          {},
          this.AliplayerV2Opts_default,
          this.options
        )
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.videoAliplyerV2Single {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  /* border-radius: 1.3vw;
  box-shadow: 0 1.1vw 2.6vw 0 rgba(0, 0, 0, 0.15); */
  background-position: left top;
  background-size: 100% auto;
  background-repeat: no-repeat;
}
</style>
<style lang="scss">
.videoAliplyerV2Single {
  .prism-player {
    .prism-big-play-btn {
      transform: translate(-50%, 50%);
      width: 4.166vw;
      height: 4.166vw;
      .outter {
        width: 4.583vw;
        height: 4.583vw;
        border: 0.416vw solid rgba(255, 255, 255, 1);
        opacity: 0.5;
        margin: -0.208vw 0 0 -0.208vw;
      }
    }
    .prism-thumbnail {
      left: 50% !important;
      width: 12.083vw;
      height: 6.805vw;
      bottom: 3.472vw;
    }
    .prism-info-left-bottom {
      bottom: 4.86vw;
      left: 1.38vw !important;
      height: 3.056vw;
      line-height: 1.944vw;
      font-size: 1.11vw;
      padding: 0.694vw 0.833vw;
    }
    .prism-volume-control {
      margin-right: 0.347vw !important;
      margin-top: 0.694vw !important;
      bottom: 3.056vw;
      background: rgba(60, 60, 60, 0.95);
      box-shadow: 0 0 6px 0 rgb(0 0 0 / 10%);
      width: 2.222vw;
      height: 9.027vw;
      .volume-range {
        left: 0.972vw;
        bottom: 0.694vw;
        border-radius: 1px;
        background: #6c6262;
        box-shadow: inset 1px 1px 1px 0 rgb(0 0 0 / 6%);
        width: 0.278vw;
        height: 6.94vw;
      }
      .volume-cursor {
        width: 1.042vw;
        height: 1.042vw;
        border-radius: 1.042vw;
        left: -0.416vw;
      }
    }
    .prism-controlbar {
      height: 3.056vw;
      font-size: 0.972vw;
      .prism-controlbar-bg {
        height: 2.778vw;
        background: rgba(75, 75, 75, 0.15);
      }
    }
    .prism-play-btn {
      margin-left: 0.833vw !important;
      margin-top: 0.833vw !important;
      width: 1.667vw;
      height: 1.667vw;
    }
    .prism-time-display {
      margin-left: 0.694vw !important;
      margin-top: 0.486vw !important;
      height: 2.778vw;
      line-height: 2.778vw;
    }
    .prism-volume {
      margin-right: 0.347vw !important;
      margin-top: 0.694vw !important;
      .volume-icon {
        width: 1.944vw;
        height: 1.944vw;
        .short-horizontal {
          width: 0.208vw;
          background: #ebecec;
          height: 0.556vw;
          right: 0.694vw;
        }
        .long-horizontal {
          width: 0.208vw;
          background: #ebecec;
          height: 1.25vw;
          right: 0.347vw;
        }
      }
    }
    .prism-fullscreen-btn {
      margin-right: 0.694vw !important;
      margin-top: 0.833vw !important;
      width: 1.944vw;
      height: 1.944vw;
    }
    .prism-liveshift-progress,
    .prism-progress {
      height: 0.278vw;
      bottom: 2.778vw !important;
      background: rgba(195, 197, 198, 0.5);
      .prism-progress-cursor {
        border-radius: 50%;
        top: -0.347vw;
        width: 1.11vw;
        height: 1.11vw;
      }
    }

    .prism-button {
      font-size: 1.11vw;
      border: 1px #fff solid;
      padding: 0.138vw 0.347vw;
      color: #fff;
      background: #503f3f63;
    }
    .prism-auto-stream-selector {
      bottom: 60%;
      .operators {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 40%;
      }
    }
    .prism-marker-text {
      padding: 0.347vw;
      background: rgba(0, 0, 0, 0.8);
      position: absolute;
      left: 10%;
      max-width: 80%;
      max-height: 46%;
      bottom: 7%;
      color: #fff;
      border-radius: 0.208vw;
      z-index: 9999;
      display: none;
      overflow: auto;
    }
  }
}
</style>
